// ============================================================
// OAMATECH ERP PRO - Contexto de autenticación
// ============================================================
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Al montar: recuperar sesión guardada
  useEffect(() => {
    const token    = sessionStorage.getItem('oamatech_token');
    const userStr  = sessionStorage.getItem('oamatech_usuario');
    if (token && userStr) {
      try {
        setUsuario(JSON.parse(userStr));
      } catch {
        sessionStorage.clear();
      }
    }
    setCargando(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    sessionStorage.setItem('oamatech_token',   data.token);
    sessionStorage.setItem('oamatech_usuario', JSON.stringify(data.usuario));
    setUsuario(data.usuario);
    toast.success(`Bienvenido, ${data.usuario.nombre}`);
    return data.usuario;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem('oamatech_token');
    sessionStorage.removeItem('oamatech_usuario');
    // Limpiar la tienda activa: si no, el siguiente usuario entraria en la tienda del anterior
    localStorage.removeItem('oamatech_tienda_activa');
    localStorage.removeItem('oamatech_tienda_nombre');
    sessionStorage.removeItem('oamatech_tienda_activa');
    sessionStorage.removeItem('oamatech_tienda_nombre');
    setUsuario(null);
    toast('Sesión cerrada');
  }, []);

  // Helpers de permisos
  const esAdmin    = usuario?.rol === 'admin';
  const esTecnico  = ['admin', 'encargado', 'tecnico'].includes(usuario?.rol);
  const puedeVer   = (rol) => {
    const niveles = { admin: 3, tecnico: 2, recepcion: 1 };
    return (niveles[usuario?.rol] || 0) >= (niveles[rol] || 0);
  };

  return (
    <AuthContext.Provider value={{ usuario, cargando, login, logout, esAdmin, esTecnico, puedeVer }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
}
